module.exports = __webpack_public_path__ + "fa-solid-900.64d495f582d4a1590a6c9eda3f2e9d2d.hashedasset.woff2";